import React, { Dispatch, SetStateAction, createContext, useState } from "react";

export interface IProfile {
  profileName: string;
  profileID: string;
  defaultTeamId: string;
  hasUADownloadAccess: boolean;
}

export interface IAppContext {
  selectedProfile: IProfile | null;
  setSelectedProfile: Dispatch<SetStateAction<IProfile | null>>;
  isSheetAddedOrRemoved: boolean;
  setIsSheetAddedOrRemoved: Dispatch<SetStateAction<boolean>>;
}

export const AppContext = createContext<IAppContext>({} as IAppContext);

export const AppProvider = ({ children }) => {
  const [selectedProfile, setSelectedProfile] = useState<IProfile | null>(null);
  const [isSheetAddedOrRemoved, setIsSheetAddedOrRemoved] = useState<boolean>(false);
  return (
    <AppContext.Provider
      value={{ selectedProfile, setSelectedProfile, isSheetAddedOrRemoved, setIsSheetAddedOrRemoved }}
    >
      {children}
    </AppContext.Provider>
  );
};
